import { useState } from 'react'

import { ReactComponent as Checkmark } from '../../../../assets/icons/checkmark.svg'

import styles from './edit-url.module.scss'

interface IEditUrlProps {
    url: string
    handleSubmit: (url: string) => void
}

function EditUrl(props: IEditUrlProps) {
    const { url, handleSubmit } = props

    const [urlToEdit, setUrlToEdit] = useState(url)

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        handleSubmit(urlToEdit)
    }

    return (
        <form className={styles.editUrl} onSubmit={handleFormSubmit}>
            <input
                className={styles.editUrl__input}
                type="text"
                value={urlToEdit}
                onChange={(e) => setUrlToEdit(e.target.value)}
            />
            <button className={styles.editUrl__btn} type="submit">
                <Checkmark className={styles.editUrl__icon} />
            </button>
        </form>
    )
}

export default EditUrl
